export type HarborMap = Record<string, string[]>;

export const harborMapping: HarborMap = {
  Bebek: ['Beşiktaş', 'Arnavutköy', 'Ortaköy', 'Kuruçeşme'],
  Kuruçeşme: ['Bebek', 'Ortaköy', 'Beşiktaş'],
  Ortaköy: ['Beşiktaş', 'Arnavutköy', 'Kuruçeşme'],
  Beşiktaş: ['Kabataş', 'Karaköy', 'Ortaköy', 'Kuruçeşme'],
  Kabataş: ['Karaköy', 'Eminönü', 'Beşiktaş'],
  Eminönü: ['Karaköy', 'Unkapanı', 'Ayvansaray'],
  Karaköy: ['Eminönü', 'Kabataş', 'Unkapanı'],
  Unkapanı: ['Eminönü', 'Karaköy', 'Ayvansaray'],
  Ayvansaray: ['Unkapanı', 'Eminönü'],
  Arnavutköy: ['Bebek', 'Kuruçeşme', 'Sarıyer'],
  Sarıyer: ['Kireçburnu', 'İstinye', 'Arnavutköy'],
  Kireçburnu: ['Sarıyer', 'İstinye'],
  İstinye: ['Kireçburnu', 'Sarıyer'],
  // Büyükçekmece: ['Beylikdüzü', 'Esenyurt'],

  // Asian Side
  Kandilli: ['Beylerbeyi', 'Üsküdar', 'Anadolu Hisarı'],
  Kuleli: ['Kandilli', 'Anadolu Hisarı', 'Göksu Deresi'],
  'Anadolu Hisarı': ['Göksu Deresi', 'Kuleli', 'Beykoz'],
  'Göksu Deresi': ['Anadolu Hisarı', 'Beykoz'],
  Beykoz: ['Göksu Deresi', 'Anadolu Hisarı', 'Beylerbeyi'],
  Beylerbeyi: ['Üsküdar', 'Kandilli', 'Beykoz'],
  Üsküdar: ['Harem', 'Kadıköy', 'Beylerbeyi'],
  Harem: ['Üsküdar', 'Kadıköy'],
  Kadıköy: ['Harem', 'Fenerbahçe', 'Kartal'],
  Fenerbahçe: ['Kadıköy', 'Küçükyalı'],
  Küçükyalı: ['Kartal', 'Fenerbahçe'],
  Kartal: [
    'Küçükyalı',
    // 'Maltepe'
  ],
};

/**
 * Helper function to get nearby harbors by harbor name
 * @param harborName The name of the harbor to find neighbors for
 * @returns Array of nearby harbor names or empty array if not found
 */
export const getNearbyHarbors = (harborName: string): string[] => {
  return harborName in harborMapping ? harborMapping[harborName] : [];
};

export const harborMappingService = {
  getNearbyHarbors,
  harborMapping,
};

export default harborMappingService;
